import { useCallback, useRef } from 'react'
import { BottomSheetModal } from '@gorhom/bottom-sheet'
import { useStore } from '../../models'

export const useNotificationSheet = () => {
  const {
    session: { setIsPNSheetOpen }
  } = useStore()

  const bottomNotificationSheetModalRef = useRef<BottomSheetModal>(null)

  const openBottomModal = useCallback(
    (dayOfWeek?: number) => {
      setIsPNSheetOpen(true)
      // Defer present() so ref is attached (e.g. when invoked from press handler)
      const open = () => {
        if (bottomNotificationSheetModalRef.current) {
          bottomNotificationSheetModalRef.current.present({ dayOfWeek })
        } else {
          console.warn('[useNotificationSheet] ref.current is null, modal will not open')
        }
      }
      if (typeof requestAnimationFrame !== 'undefined') {
        requestAnimationFrame(open)
      } else {
        setTimeout(open, 0)
      }
    },
    [setIsPNSheetOpen]
  )
  const closeBottomModal = useCallback(() => {
    setIsPNSheetOpen(false)
    bottomNotificationSheetModalRef.current?.close()
  }, [bottomNotificationSheetModalRef, setIsPNSheetOpen])

  const handleOpenNotificationSheet = (dayOfWeek?: number) => openBottomModal(dayOfWeek)

  return {
    // Modal props
    bottomNotificationSheetModalRef,
    closeBottomModal,
    // Handlers
    handleOpenNotificationSheet
  }
}
